/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Kargo_EtiketiInputs */

const tr_faq_q_kargo_etiketi = /** @type {(inputs: Faq_Q_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo etiketi nasıl bastırılır?`)
};

const en_faq_q_kargo_etiketi = /** @type {(inputs: Faq_Q_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I print a shipping label?`)
};

const de_faq_q_kargo_etiketi = /** @type {(inputs: Faq_Q_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie drucke ich ein Versandetikett?`)
};

const ru_faq_q_kargo_etiketi = /** @type {(inputs: Faq_Q_Kargo_EtiketiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как распечатать этикетку доставки?`)
};

/**
* | output |
* | --- |
* | "How do I print a shipping label?" |
*
* @param {Faq_Q_Kargo_EtiketiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_kargo_etiketi = /** @type {((inputs?: Faq_Q_Kargo_EtiketiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Kargo_EtiketiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_kargo_etiketi(inputs)
	if (locale === "de") return de_faq_q_kargo_etiketi(inputs)
	if (locale === "ru") return ru_faq_q_kargo_etiketi(inputs)
	return tr_faq_q_kargo_etiketi(inputs)
});